import React from 'react'
import { CircularProgress, Dialog, DialogTitle } from '@mui/material';
import { Stack } from '@mui/system';

const LoaderDialog = ({open, title}) => {
  return (
    <Dialog open={open} fullWidth={true}>
      <Stack direction="row" >
        <CircularProgress sx={{margin: 1}} />
        <DialogTitle>{title}</DialogTitle>
      </Stack>
    </Dialog>
  )
}

export default LoaderDialog
